
export const getField = (activeFilter, category) => {
    // Stories
    if (activeFilter === 'Story Type') return 'newTag5';
    if (activeFilter === 'Top Websites') return 'newTag8';
    if (activeFilter === 'Top Authers') return 'newTag8';
    if (activeFilter === 'Industry') return 'industry';
    if (activeFilter === 'Author Type') return 'newTag7';

    //Threats
    if (activeFilter === 'Threat Type') return 'newTag6';
    if (activeFilter === 'Attack Stage') return 'newTag7';
    if (activeFilter === 'Sub Category' && category === 'Threats') return 'subCategory';
    if (activeFilter === 'Industry' && category === 'Threats') return 'industry';

    //Solutions
    if (activeFilter === 'Solution Type') return 'newTag8';
    if (activeFilter === 'Industry' && category === 'Solutions') return 'industry';
    if (activeFilter === 'Sub Category' && category === 'Solutions') return 'subCategory';

    //Companies
    if (activeFilter === 'Sub Category' && category === 'Companies') return 'tileTop';
    if (activeFilter === 'Product Type') return 'newTag7';
    if (activeFilter === 'HQ Location') return 'newTag5';
}

//function to convert the wix image url to http url
export function getImageUrl(image) {
    let url;
    if (typeof image === 'string') url = image;
    if (image && image.default) url = image.default;
    if (url && url.includes('/static/media/PlaceHolderImage')) return getRandomImage();
    if (url && !url.includes('wix:image://v1/')) return url;
    if (url && url.includes('wix:image://v1/')) {
        url = url.replace('wix:image://v1/', '');
        let index;
        if (url.includes('jpg')) index = url.indexOf('.jpg') + 4;
        if (url.includes('jpeg')) index = url.indexOf('.jpeg') + 5;
        if (url.includes('png')) index = url.indexOf('.png') + 4;

        url = url.substr(0, index)
        url = 'https://static.wixstatic.com/media/' + url;
        return url
    }
}

//functions to get a random image from the array of fallback images
export function getRandomImage() {
    const images = [
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%201-1601284076467.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%202-1601283910390.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%203-1601283931483.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%204-1601283946331.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%205-1601283962151.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%206-1601283975789.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%207-1601283988750.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%208-1601284001627.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%209-1601284019713.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%2010-1601284033519.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%2011-1601284049172.jpg',
        'https://trukno.s3.us-east-2.amazonaws.com/Random%20Cyber%20Image%2012-1601284060780.jpg'
    ];
    const randomIndex = Math.floor(Math.random() * (10 - 0)) + 0;
    return images[randomIndex];
}

//function to format the numbers with commas
export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getDate(date) {
    var a = new Date(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var month = months[a.getMonth()];
    var day = a.getDate();
    return (`${day} ${month}`)
}

export function formatDate(date, format) {
    //format 'day year' | 'day month, year'
    var a = new Date(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = a.getFullYear();
    var yearSmall = a.getFullYear().toString().substr(2);
    var month = months[a.getMonth()];
    var monthSmall = a.getMonth() + 1;
    var day = a.getDate();
    return format
        .replace('day', day)
        .replace('monthSmall', monthSmall)
        .replace('month', month)
        .replace('yearSmall', yearSmall)
        .replace('year', year)
}

export function deepCompare() {
    var i, l, leftChain, rightChain;

    function compare2Objects(x, y) {
        var p;

        // remember that NaN === NaN returns false
        // and isNaN(undefined) returns true
        if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
            return true;
        }

        // Compare primitives and functions.     
        // Check if both arguments link to the same object.
        // Especially useful on the step where we compare prototypes
        if (x === y) {
            return true;
        }

        // Works in case when functions are created in constructor.
        // Comparing dates is a common scenario. Another built-ins?
        // We can even handle functions passed across iframes
        if ((typeof x === 'function' && typeof y === 'function') ||
            (x instanceof Date && y instanceof Date) ||
            (x instanceof RegExp && y instanceof RegExp) ||
            (x instanceof String && y instanceof String) ||
            (x instanceof Number && y instanceof Number)) {
            return x.toString() === y.toString();
        }

        // At last checking prototypes as good as we can
        if (!(x instanceof Object && y instanceof Object)) {
            return false;
        }

        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }

        if (x.constructor !== y.constructor) {
            return false;
        }

        if (x.prototype !== y.prototype) {
            return false;
        }

        // Check for infinitive linking loops
        if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
        }

        // Quick checking of one object being a subset of another.
        // todo: cache the structure of arguments[0] for performance
        for (p in y) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            }
            else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
        }

        for (p in x) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            }
            else if (typeof y[p] !== typeof x[p]) {
                return false;
            }

            switch (typeof (x[p])) {
                case 'object':
                case 'function':

                    leftChain.push(x);
                    rightChain.push(y);

                    if (!compare2Objects(x[p], y[p])) {
                        return false;
                    }

                    leftChain.pop();
                    rightChain.pop();
                    break;

                default:
                    if (x[p] !== y[p]) {
                        return false;
                    }
                    break;
            }
        }

        return true;
    }

    if (arguments.length < 1) {
        return true; //Die silently? Don't know how to handle such case, please help...
        // throw "Need two or more arguments to compare";
    }

    for (i = 1, l = arguments.length; i < l; i++) {

        leftChain = []; //Todo: this can be cached
        rightChain = [];

        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }

    return true;
}